import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import {
  ContainerTable,
  DataCellWrapper,
  EffortWrapper,
  HeaderCelDate,
  HeaderCellWrapper,
  TableCustom,
  TableWrapper,
  Wrappertable,
} from '@/components/pages/ClientDevice/styles'
import { GetTotalClientDeviceByRangeDayResponse } from '@/types/apis/clientDevice'

type Props = {
  responseTotalClientDevice: GetTotalClientDeviceByRangeDayResponse
  responseTotalClientDeviceLoading?: boolean
}

const TotalClientDeviceByRangeDayTable = ({ responseTotalClientDevice, responseTotalClientDeviceLoading }: Props) => {
  const { t } = useTranslation()
  const dataSource = responseTotalClientDevice.items

  return (
    <ContainerTable>
      <Spin spinning={responseTotalClientDeviceLoading}>
        <TableWrapper>
          <EffortWrapper>{t('components.pages.clientDevice.listReport.table.hour')}</EffortWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <tr>
                  <HeaderCelDate>{t('components.pages.clientDevice.listReport.table.date')}</HeaderCelDate>
                  {dataSource?.map((item, index) => (
                    <HeaderCellWrapper key={index}>{item.name}</HeaderCellWrapper>
                  ))}

                  <HeaderCellWrapper>{t('components.pages.clientDevice.listReport.table.total')}</HeaderCellWrapper>
                </tr>
                {dataSource.length ? (
                  <tr>
                    <DataCellWrapper>{}</DataCellWrapper>
                    {dataSource?.map((item, index) => (
                      <DataCellWrapper key={index}>
                        {item.workingTime ? item.workingTime.toFixed(1) : undefined}
                      </DataCellWrapper>
                    ))}
                    <DataCellWrapper>{responseTotalClientDevice?.totalWorkingTime.toFixed(1)}</DataCellWrapper>
                  </tr>
                ) : null}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
TotalClientDeviceByRangeDayTable.displayName = 'TotalClientDeviceByRangeDayTable'
export default TotalClientDeviceByRangeDayTable
